import { stringField, booleanField } from 'common/utils/form/fieldTypes';

export default {
  active: booleanField(),
  synonyms: {
    value: stringField({ required: true })
  }
};
